"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DebugSurfaceDrawingSystem = void 0;
var core_1 = require("@inter-ikea-core/core");
var SystemBase2_1 = require("../systembase/SystemBase2");
var DebugSurfaceCleanupSystem_1 = require("./DebugSurfaceCleanupSystem");
var ViewerSurfaceReferenceComponent_1 = require("./ViewerSurfaceReferenceComponent");
/*
 * Small system that draws debug surfaces using the IPEXViewerCoreAdapter.
 */
var DebugSurfaceDrawingSystem = /** @class */ (function (_super) {
    __extends(DebugSurfaceDrawingSystem, _super);
    function DebugSurfaceDrawingSystem(viewer, entityManager) {
        var _this = _super.call(this, core_1.ComponentIds.DEBUG_SURFACES_COMPONENT, core_1.ComponentIds.UPDATED_FROM_SNAPSHOT_EVENT_COMPONENT_ID) || this;
        _this.doingChangesOnComponent = [];
        _this.id = DebugSurfaceDrawingSystem.ID;
        _this.systemsAfterMe = [DebugSurfaceCleanupSystem_1.DebugSurfaceCleanupSystem.ID];
        _this.systemsBeforeMe = null;
        _this.entityManager = entityManager;
        _this.viewer = viewer;
        return _this;
    }
    DebugSurfaceDrawingSystem.prototype.onAddComponent = function (entity, _newComponent) {
        this.updateSurfaces(entity);
    };
    DebugSurfaceDrawingSystem.prototype.onRemoveComponent = function (entity, _oldComponent) {
        if (entity.hasComponent(ViewerSurfaceReferenceComponent_1.ViewerSurfaceReferenceComponent.ID)) {
            entity.removeComponent(ViewerSurfaceReferenceComponent_1.ViewerSurfaceReferenceComponent.ID);
        }
    };
    DebugSurfaceDrawingSystem.prototype.onUpdateComponent = function (entity, _oldComponent, _newComponent) {
        this.updateSurfaces(entity);
    };
    DebugSurfaceDrawingSystem.prototype.onAddComponent2 = function (_entity, _newComponent) {
        // Do nothing
    };
    DebugSurfaceDrawingSystem.prototype.onUpdateComponent2 = function (_entity, _oldComponent, _newComponent) {
        // Do nothing
    };
    DebugSurfaceDrawingSystem.prototype.onRemoveComponent2 = function (_entity, oldComponent) {
        // Run this on onRemove so that the cleanup in DebugSurfaceCleanupSystem has run before this.
        if (oldComponent.entity) {
            this.updateSurfaces(oldComponent.entity);
        }
    };
    DebugSurfaceDrawingSystem.prototype.updateSurfaces = function (entity) {
        var _this = this;
        var viewerSurfaceReferenceComponent = entity.getComponent(ViewerSurfaceReferenceComponent_1.ViewerSurfaceReferenceComponent.ID);
        if (viewerSurfaceReferenceComponent) {
            entity.removeComponent(ViewerSurfaceReferenceComponent_1.ViewerSurfaceReferenceComponent.ID);
        }
        var debugSurfaceComponent = entity.getComponent(core_1.ComponentIds.DEBUG_SURFACES_COMPONENT);
        var surfaceObjects = debugSurfaceComponent === null || debugSurfaceComponent === void 0 ? void 0 : debugSurfaceComponent.surfaces;
        var viewerObjects = [];
        surfaceObjects === null || surfaceObjects === void 0 ? void 0 : surfaceObjects.forEach(function (surface) {
            var viewerObject = _this.viewer.createSurface(surface.vertices, surface.normal, entity);
            viewerObject.setVisible(true);
            viewerObjects.push(viewerObject);
        });
        this.entityManager.addComponent(entity, new ViewerSurfaceReferenceComponent_1.ViewerSurfaceReferenceComponent(viewerObjects));
    };
    DebugSurfaceDrawingSystem.ID = "debugSurfaceDrawingSystem";
    return DebugSurfaceDrawingSystem;
}(SystemBase2_1.SystemBase2));
exports.DebugSurfaceDrawingSystem = DebugSurfaceDrawingSystem;
//# sourceMappingURL=DebugSurfaceDrawingSystem.js.map